import axios from "../axios-config";

export const trackUserActivity = async (activityType, metadata = {}) => {
    const response = await axios.post("/user/v1/activity/track", {
        activityType,
        metadata,
    });
    return response?.data?.data || { isFirstVisit: false, visitCount: 0, milestonesReached: [] };
};
